import type { Middleware, Reducer } from "@reduxjs/toolkit";

import type { NodeAction } from "../../schemas/index.ts";
import type { NodeDesignsReducer, NodeDesignsReducerOptions, NotifyNodeDesignsEvent } from "../reducer/index.ts";
import type { NodeDesignsActionInterceptor, UnsentActionsStorageOptions } from "./middleware/index.ts";
import type { NautilusDesignerState } from "./nautilusState.ts";
import type { SendActionToServer } from "./serverActions.ts";

export interface NautilusStoreOptions<AppConfig extends Record<string, unknown> = Record<string, unknown>> {
  createNodeDesignsReducer: (options: Pick<NodeDesignsReducerOptions, "notifyEvent">) => NodeDesignsReducer;
  createAppConfigReducer: () => Reducer<AppConfig>;
  publishNodeDesignsEvent: NotifyNodeDesignsEvent;
  sendActionToServer: SendActionToServer;
  nodeDesignsActionInterceptors?: NodeDesignsActionInterceptor[];
  /**
   * Extra middleware, run ahead of everything the store adds. Where an
   * interceptor sees node designs alone, these see the whole state — including
   * the app config a manifest-derived answer needs.
   */
  middleware?: Middleware<{}, NautilusDesignerState<AppConfig>>[];
  onUnsentActionsChanged?: UnsentActionsStorageOptions;
}

/** DJB2 hash of JSON-serialized actions → signed 32-bit integer. Synchronous for use in reducers. */
export const computeRevisionChecksum = (actions: NodeAction[]): number => {
  const str = JSON.stringify(actions);
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) | 0;
  }
  return hash;
};
